import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatNumber } from '@angular/common';

@Pipe({
  name: 'currencyFormatter'
})
export class CurrencyFormatterPipe implements PipeTransform {
  constructor() {

  }
  transform(value: number, symbol?: any): any {
    let sign = '';
    if (isNaN(value) || value === null) {
      return '';
    }
    if (!symbol) {
      symbol = '€';
    }
    if (value < 0) {
      sign = '-';
      value = value*-1;
    }
    if (value >= 1000000000) {
      return sign + (value / 1000000000).toFixed(2) + 'B';
    }
    else if (value >= 1000000) {
      return sign + (value / 1000000).toFixed(2) + 'M';
    } else if (value >= 1000) {
      return sign + (value / 1000).toFixed(0) + 'K';
    } else {
      return sign + value.toString() + symbol;
    }

  }

}
